<select class="input minimal" (change)="addDiscountCodeFilter($event)" [value]="SelectedDiscountFilter">
    <option [selected]="true" value="Active">Active</option>
    <option value="Expired">Expired</option>
    <option value="Revoked">Revoked</option>
    <option value="All">All</option>
</select>
